export default __webpack_public_path__ + "img/d085ae09153636b3ff90b3a78c5c9cf2.png";